import { colors } from "../../../styles/figmaColors";
import { useTranslation } from "react-i18next";
import { Tag } from "../Tag/Tag";
import "../../../../i18n/i18n";

type ElectricChargeType = "STATION" | "HOME" | "ON_SITE";
const typeEnum = ["STATION", "HOME", "ON_SITE"];

const typeProps = {
  STATION: {
    backgroundColor: colors["colors/system/success/success_ultraLight"],
    textColor: colors["colors/system/success/success_normal"],
  },
  HOME: {
    backgroundColor: colors["colors/surfaces/background/background_level1"],
    textColor: colors["colors/text/darkGrey"],
  },
  ON_SITE: {
    backgroundColor: colors["colors/system/informative/informative_ultraLight"],
    textColor: colors["colors/system/informative/informative_normal"],
  },
};

interface TableTagElectricChargeTypeProps {
  type: string;
}

export const TableTagElectricChargeType = (
  props: TableTagElectricChargeTypeProps,
) => {
  const { t } = useTranslation();
  const typeTranslated = typeEnum.find(
    (type) => t(`electric_charging.type.${type}`) === props.type,
  );
  if (!typeTranslated) {
    return null;
  }
  const chargeType = typeProps[typeTranslated as ElectricChargeType];

  return (
    <Tag
      text={props.type}
      backgroundColor={chargeType.backgroundColor}
      textColor={chargeType.textColor}
    />
  );
};
